import React from 'react'
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { advancedColors, surfaces } from '../theme'
import { TOUR_ANCHORS } from '../tour/anchors'
import { CASELOAD_VIEWS, CaseloadView } from './caseloadView'

type Props = {
  view: CaseloadView
  onChange: (view: CaseloadView) => void
}

const CaseloadViewSwitch = ({ view, onChange }: Props) => (
  <Box sx={{ px: 2, pt: 2 }}>
    <ToggleButtonGroup
      data-tour={TOUR_ANCHORS.caseloadView}
      exclusive
      fullWidth
      size="small"
      value={view}
      aria-label="Caseload view"
      onChange={(_event, next: CaseloadView | null) => next && onChange(next)}
      sx={{
        '& .MuiToggleButton-root': {
          textTransform: 'none',
          fontSize: 12,
          py: 0.5,
          backgroundColor: advancedColors.surface,
          borderColor: surfaces.green.stroke,
          color: advancedColors.deep,
          '&:hover': { backgroundColor: advancedColors.canvas },
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: advancedColors.green,
            borderColor: advancedColors.green,
            color: advancedColors.surface,
          },
        },
      }}
    >
      {CASELOAD_VIEWS.map((option) => (
        <ToggleButton key={option.id} value={option.id}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Box>
)

export default CaseloadViewSwitch
